import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FiBarChart2,
  FiBriefcase,
  FiFileText,
  FiGrid,
  FiHome,
  FiLayers,
  FiSettings,
  FiShield,
  FiShoppingBag,
  FiUsers,
} from 'react-icons/fi';
import { FaPesoSign } from 'react-icons/fa6';
import { useAuth } from '../context/AuthContext';
import { getAccessibleNavItems } from '../navigation/appNavigation';

const ICON_MAP = {
  dashboard: FiHome,
  productSetup: FiLayers,
  agents: FiUsers,
  sales: FiShoppingBag,
  collections: FaPesoSign,
  commissions: FiBarChart2,
  finance: FiBriefcase,
  branchAdmin: FiGrid,
  reports: FiFileText,
  admin: FiShield,
  default: FiSettings,
};

function resolveIcon(iconKey) {
  return ICON_MAP[iconKey] || ICON_MAP.default;
}

export default function Sidebar({ isCollapsed, isMobileOpen, onCloseMobileMenu }) {
  const location = useLocation();
  const { user } = useAuth();
  const userScopes = Array.isArray(user?.scopes) ? user.scopes : [];
  const accessibleNavItems = useMemo(
    () => getAccessibleNavItems(userScopes),
    [userScopes]
  );

  const activeItem = useMemo(
    () => accessibleNavItems.find((item) => item.path === location.pathname),
    [accessibleNavItems, location.pathname]
  );

  const navContent = (
    <div className="sidebar-panel">
      <a
        className="sidebar-brand"
        href="https://findesk.rmc2.com.ph/"
        target="_blank"
        rel="noreferrer"
      >
        <img src="/logo512.png" alt="RMC2" className="sidebar-brand-logo" />
        <div>
          <h1>RMC2 Findesk</h1>
          <p>Operations workspace</p>
        </div>
      </a>

      <div className="sidebar-user-card">
        <span className="sidebar-user-label">Logged in as</span>
        <strong>{user?.full_name || user?.username || 'User'}</strong>
        <p>{activeItem?.label || 'Dashboard'}</p>
      </div>

      <nav className="sidebar-nav">
        <span className="sidebar-nav-label">Main Menu</span>
        {accessibleNavItems.map((item) => {
          const Icon = resolveIcon(item.iconKey);
          const isActive = location.pathname === item.path;

          return (
            <Link
              key={item.path}
              to={item.path}
              onClick={onCloseMobileMenu}
              className={`sidebar-link ${isActive ? 'is-active' : ''}`}
              title={item.label}
            >
              <Icon className="sidebar-link-icon" />
              <span className={`sidebar-link-text ${isCollapsed ? 'is-hidden' : ''}`}>{item.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        <a
          className="sidebar-powered-by"
          href="https://hunterlabs.solutions/"
          target="_blank"
          rel="noreferrer"
        >
          <img src="/logo192-hlabs-white.png" alt="HunterLabs" className="sidebar-hunterlabs-logo" />
          <span className="sidebar-powered-by-text">HunterLabs</span>
        </a>
      </div>
    </div>
  );

  return (
    <>
      {isMobileOpen ? <div className="sidebar-overlay" onClick={onCloseMobileMenu} /> : null}

      <aside className={`sidebar sidebar-mobile ${isMobileOpen ? 'is-open' : ''}`}>
        {navContent}
      </aside>

      <aside className={`sidebar sidebar-desktop ${isCollapsed ? 'is-collapsed' : ''}`}>{navContent}</aside>
    </>
  );
}
